import { auth } from "../firebase/firebaseConfig";
import { STRIPE_BASE } from "./config";

export async function fetchCurrentAccess() {
  const currentUser = auth.currentUser;
  if (!currentUser) throw new Error("Sign in is required.");
  const token = await currentUser.getIdToken();
  const response = await fetch(`${STRIPE_BASE}/access/me`, {
    headers: { Authorization: `Bearer ${token}` },
    credentials: "include",
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload?.error || `Access request failed (${response.status})`);
    error.status = response.status;
    throw error;
  }
  return payload;
}
